<template>
  <div class="skillsetting-block">
    <el-form ref="form" :model="form" style="width: 60%" size="small" label-width="130px">
      <el-form-item label="技能组ID：">
        <label>{{ storeClickSkillGroupId }}</label>
      </el-form-item>
      <el-form-item label="技能组名称：">
        <el-input placeholder="VIP客户服务组,技能组名称最大长度8个字" :disabled="disableInput()" maxlength="8" v-model="skillName"></el-input>
      </el-form-item>
    </el-form>
    <div class="block-title clearfix">
      <h4>技能组业务设置</h4>
    </div>
    <el-form ref="form" :model="ywform" size="small" label-width="130px">
        <!-- <div class="block-content-title">
          <div class="pull-left">业务{{index+1}}</div>
        </div> -->
        <div style="width: 60%">
          <el-form-item label="业务类型：" >
            <el-select placeholder="请选择" v-model="ywform.bizType" @change="changeBizType" style="width: 100%">
              <el-option v-for="(bizType, typeIdx) in bizTypeMap" :key="typeIdx" :label="bizType.name" :value="bizType.tag"></el-option>
            </el-select>
          </el-form-item>
          <div v-for="(item, index) in bizTypes" :key="index">
            <el-form-item v-for="(bizItem, itemIdx) in item.bizItems" :key="itemIdx" :label="bizItem.label">
              <template v-if="bizItem.type == 'select'">
                <el-select placeholder="请选择" @input="change($event)" v-model="ywform[bizItem.name]" style="width: 100%">
                  <el-option v-for="(dictItem, dicIdx) in bizItem.dictItems" :key="dicIdx" :label="dictItem.name" :value="dictItem.value"></el-option>
                </el-select>
              </template>
              <template v-else-if="bizItem.type == 'textarea'">
                <el-input type="textarea" maxlength="200" v-model="ywform[bizItem.name]" @input="change($event)" :name="bizItem.name" :placeholder="bizItem.defaultValue"></el-input>
                <div class="alert alert-danger" v-if="bizItem.tip">
                  <span class="icon-wrapper">!</span>
                  <span class="text-info">{{ bizItem.tip }}</span>
                </div>
              </template>
              <template v-else-if="bizItem.type == 'number'">
                <el-input-number :min="1" v-model="ywform[bizItem.name]" @input="change($event)" :name="bizItem.name" :placeholder="bizItem.defaultValue"></el-input-number>
                <span v-if="bizItem.name == 'socketWaitHour'" style="margin-left: 10px;color: #606266;font-size: 14px;">分钟</span>
              </template>
              <template v-else-if="bizItem.type == 'text'">
                <el-input v-model="ywform[bizItem.name]" maxlength="12" @input="change($event)" :name="bizItem.name" :placeholder="bizItem.defaultValue"></el-input>
              </template>
              <template v-else-if="bizItem.type == 'agent_avatar'">
                <span>
                  <el-upload style="width:auto;float:left;" :before-upload="beforeImageUpload" :on-success="handleImageUpload" :show-file-list="false" :headers="headers" :with-credentials="true" :action="imageUploadAction">
                    <el-avatar shape="square" :size="80" :src="imageSrc" style="margin-right:10px;" :key="imageSrc"></el-avatar>
                    <span class="link">
                      <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                        <use xlink:href="#iconxiangji" />
                      </svg>
                      <span>修改头像</span>
                    </span>
                  </el-upload>
                  <span class="link" style="margin-left:5px;line-height:14px;height:20px;white-space:nowrap;position:absolute;left:160px;top:67px;" @click="deleteImg">
                    <svg class="icon icon-delete" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                      <use xlink:href="#icontable-delete" />
                    </svg>
                    <span>删除头像</span>
                  </span>
                  <span style="float:left;margin-top:-10px;width:100%;color:#999;">大小：不超过1M，格式：png,jpg,gif</span>
                </span>
              </template>
              <template v-else-if="bizItem.type == 'quick_reply'">
                <div class="pull-left">已设置 <span class="text-danger">{{ quickReplyCount }}</span> 条快捷回复</div>
                <a href="javaScript:;" class="link" @click="dialogEditModify = true" style="margin-left:20px;">
                  <svg class="icon icon-bianji" aria-hidden="true" style="font-size:16px;margin-right:3px;">
                    <use xlink:href="#icontable-bianji" />
                  </svg>
                  <span>编辑修改</span>
                </a>
                <el-dialog id="dialogEditModify" title="技能组快捷回复消息" v-if="dialogEditModify" :visible.sync="dialogEditModify" width="1000px" :close-on-click-modal="false">
                  <ReplyQuickly :skillId="storeClickSkillGroupId" @updateQuickReplyCount="updateQuickReplyCount"></ReplyQuickly>
                </el-dialog>
              </template>
            </el-form-item>
            <el-row style="margin-bottom:20px;" type="flex" justify="center" v-if="
                $authUtis.hasButtonAuth(
                  'aicc-bp',
                  '/skill/addSkillGroupSetting_post'
                )
              ">
              <el-button size="medium" type="primary" @click="onSubmit">保存设置</el-button>
            </el-row>
          </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { getSkillGroupSetting, addSkillGroupSetting } from '@/api/skill'
import { mapActions } from 'vuex'
import ReplyQuickly from './ReplyQuickly'
export default {
  name: '',
  components: { ReplyQuickly },
  data() {
    return {
      dialogEditModifyInput: '',
      dialogEditModify: false,
      skillId: '',
      skillName: '',
      bizTypeMap: {},
      bizTypes: [],
      form: {},
      ywform: {
        bizType: 'cs_txt'
      },
      imageSrc: '',
      imageUploadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/upload/file?fileType=6&isTemp=false',
      imageDownloadAction: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/res/download',
      quickReplyCount: 0,
      valueList: {}
    }
  },
  watch: {
    storeClickSkillGroupId(val) {
      this._getSkillGroupSetting({ skillId: val })
    }
  },
  computed: {
    headers() {
      return {
        'X-TENANT-ID': localStorage.getItem('X-TENANT-ID')
      }
    },
    storeClickSkillGroupId() {
      return this.$store.state.user.clickSkillGroup.id
    }
  },
  mounted() {
    this.$nextTick(() => {
      this._getSkillGroupSetting({ skillId: this.storeClickSkillGroupId })
    })
  },
  methods: {
    ...mapActions('user', ['_listSkillGroup']),
    _getSkillGroupSetting({ skillId }) {
      getSkillGroupSetting({ skillId }).then((res) => {
        if (res.code === 2000) {
          var settingData = res.data
          this.skillId = settingData.skillId
          this.skillName = settingData.skillName
          this.bizTypeMap = settingData.bizTypeMap
          var valueList = settingData.valueList
          if (valueList && valueList.length > 0) {
            this.valueList = valueList
            this.initValueYwform()
          } else {
            var bizType = 'cs_txt'
            this.ywform.bizType = bizType
            this.initDefaultYwform()
          }
          if (this.bizTypes && this.bizTypes.length > 0) {
            this.quickReplyCount = settingData.quickReplyCount ? settingData.quickReplyCount : 0
            if (!this.ywform.unifiedAvatar) {
              this.imageSrc = './home/images/robotAgent.jpg'
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    disableInput() {
      return this.skillId === this.$global.defaultSkillGroupId
    },
    onSubmit() {
      var formData = this.ywform
      var valueList = []
      if (formData) {
        var bizType = formData.bizType
        for (var key in formData) {
          if (key !== 'bizType') {
            valueList.push({
              bizKey: key,
              bizValue: formData[key],
              bizType: bizType
            })
          }
        }
      }

      var data = {
        skillId: this.skillId,
        skillName: this.skillName,
        valueList: valueList
      }
      addSkillGroupSetting({ data }).then((res) => {
        if (res.code === 2000) {
          this._listSkillGroup()
          this.$message.success(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    change(e) {
      this.$forceUpdate()
    },
    // 图片上传检查
    beforeImageUpload(img) {
      const isValid = (img.type === 'image/png' || img.type === 'image/jpeg' || img.type === 'image/gif')
      const isLt2M = img.size / 1024 / 1024 < 1
      if (!isValid) {
        this.$message.error('上传头像图片只能是JPG或GIF或PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过1MB!')
      }
      return isValid && isLt2M
    },

    // 图片上传加工处理
    handleImageUpload(res) {
      this.ywform.unifiedAvatar = res.url
      this.imageSrc = this.imageDownloadAction + res.url
    },
    updateQuickReplyCount(data) {
      this.quickReplyCount = data
    },
    deleteImg() {
      this.ywform.unifiedAvatar = null
      this.imageSrc = './home/images/robotAgent.jpg'
    },
    initValueYwform(option) {
      for (let i = 0; i < this.valueList.length; i++) {
        const item = this.valueList[i]
        if (i === 0 && !option) {
          this.ywform = { bizType: item.bizType }
          this.bizTypes = [this.bizTypeMap[item.bizType]]
        }
        if (!option || item.bizType === option) {
          if (item.bizKey === 'unifiedAvatar') {
            this.imageSrc = item.bizValue === null ? './home/images/robotAgent.jpg' : (this.imageDownloadAction + item.bizValue)
            this.ywform[item.bizKey] = item.bizValue
          } else {
            this.ywform[item.bizKey] = item.bizValue
          }
        } else {
          this.initDefaultYwform()
        }
      }
    },
    initDefaultYwform() {
      for (var i = 0; i < this.bizTypes.length; i++) {
        var bizItems = this.bizTypes[i].bizItems
        if (bizItems && bizItems.length > 0) {
          for (var j = 0; j < bizItems.length; j++) {
            var bizItem = bizItems[j]
            if (bizItem.defaultValue) {
              if (bizItem.type === 'agent_avatar') {
                this.imageSrc = './home/images/robotAgent.jpg'
              } else {
                this.ywform[bizItem.name] = bizItem.defaultValue
              }
            }
          }
        }
      }
    },
    changeBizType(option) {
      this.bizTypes = [this.bizTypeMap[option]]
      this.ywform = { bizType: option }
      this.initValueYwform(option)
    }
  }
}
</script>
<style lang="scss" scoped>
h4 {
  position: relative;
  display: inline;
  padding-left: 20px;
}

.skillsetting-block {
  padding-top: 5px;

  .block-title {
    background-color: transparent;
    padding: 0;
    height: 50px;
    line-height: 50px;
    /* background-color: #f7f8fa; */
    color: #222222;
  }
  .block-title h4:before {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 2px;
    height: 17px;
    background-color: #337eff;
  }
  .block-content-title {
    height: 40px;
    line-height: 40px;
    background-color: #f5f5f5;
    padding: 0 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }
  .el-textarea {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .el-button {
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.el-avatar > img {
  width: 100%;
  object-fit:fill !important;
}
</style>
